const broadcastLocationChange = location => ({
  type: '@@router/LOCATION_CHANGE',
  location
});

export default broadcastLocationChange;
